import "../pages.scss"
import { DepartamentosState } from '../../context/departamentos/DepartamentosState';
import Datatable from "./departamentosTable/Datatable"

const DepartamentosPage = () => {
  return (
    <>
      <DepartamentosState>
        <Datatable />
      </DepartamentosState>

    </>
  )
}

export default DepartamentosPage